import { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import SEO from "@/components/SEO";

export default function BlogPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    // Load Soro embed script
    const existing = document.querySelector('script[src*="trysoro.com"]');
    if (!existing) {
      const script = document.createElement("script");
      script.src = "https://app.trysoro.com/api/embed/77159153-4e1b-4b25-8b34-837526e0e017";
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div data-testid="blog-page" className="min-h-screen bg-[#F8F9FB]">
      <SEO
        title="Blog"
        description="Original articles about neurodiversity, sensory-safe design, SEND support, and building tools that respect how your brain works. Published daily."
        path="/blog"
      />
      <Navbar />

      <main className="pt-28 pb-20 px-6 md:px-12 lg:px-20">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-sm uppercase tracking-widest text-brand-teal font-semibold mb-4">
              Our Blog
            </p>
            <h1
              data-testid="blog-title"
              className="font-heading text-3xl md:text-5xl font-bold text-[#2F3A56] leading-tight mb-4"
            >
              NeuroNest Blog
            </h1>
            <p className="text-base md:text-lg text-[#5A6376] max-w-xl mx-auto leading-relaxed">
              Stories, insights, and guides about neurodiversity, sensory support,
              and building a more inclusive world.
            </p>
          </div>

          {/* Soro Blog Embed */}
          <div id="soro-blog" className="min-h-[400px]" />
        </div>
      </main>

      <Footer />
    </div>
  );
}
